import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { WidgetLoadingGuard } from '../../share/guards'
import GeoRegions from '../share/GeoRegions'
import GeoRegionsWidgetSettingGuards from '../share/guards/GeoRegionsWidgetSettingGuards'
import GeoRegionsWidgetDataGuards from '../share/guards/GeoRegionsWidgetDataGuards'
import RunSearchEffect from './RunSearchEffect'

const AudienceGeoRegionsWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <GeoRegionsWidgetSettingGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <GeoRegionsWidgetDataGuards widgetId={widgetId}>
            <GeoRegions widgetId={widgetId} />
          </GeoRegionsWidgetDataGuards>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </GeoRegionsWidgetSettingGuards>
  </UnexpectedErrorBoundary>
)

export default AudienceGeoRegionsWidget
